export default __webpack_public_path__ + "static/media/Sarabun-Regular.6620546d.ttf";